import React from 'react';

export const handleHorizontalClicked = (
  ref: React.RefObject<Element | null>,
  direction: 'forward' | 'backward',
  onScrollCLicked: (canScrollLeft: boolean, canScrollRight: boolean) => void,
) => {
  if (ref.current) {
    if (direction === 'forward') {
      ref.current.scrollLeft += 50;
    } else {
      ref.current.scrollLeft -= 50;
    }
    handleHorizontalScroll(ref, (canScrollLeft, canScrollRight) =>
      onScrollCLicked(canScrollLeft, canScrollRight),
    );
  }
};

export const handleHorizontalScroll = (
  ref: React.RefObject<Element | null>,
  onScroll: (canScrollLeft: boolean, canScrollRight: boolean) => void,
) => {
  if (ref.current) {
    onScroll(
      ref.current.scrollLeft > 0,
      ref.current.scrollWidth - ref.current.clientWidth >
        ref.current.scrollLeft,
    );
  }
};
